<template>
    <div @mouseover="setMouseOver(true)" @mouseout="setMouseOver(false)">

        <v-toolbar v-if="!disableTitle" tile dense :color="color" class="elevation-3">

            <v-app-bar-nav-icon v-if="sideIcon">
                <v-icon>{{ sideIcon }}</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title class="white--text subtitle-2 pl-0">
                {{ title }}
            </v-toolbar-title>

            <v-fade-transition>
                <v-icon class="ml-3"
                        :color="helpIconColor"
                        @click.stop="helpClicked"
                        v-show="this.help && isMouseOver">mdi-information-outline
                </v-icon>
            </v-fade-transition>

            <v-spacer></v-spacer>

            <slot name="buttons"></slot>

        </v-toolbar>

        <v-slide-y-transition>
            <v-card :loading="loading ? 'primary' : false"
                    tile
                    v-show="!hideContents"
                    :color="backgroundColor"
                    :class="isMouseOver ? 'elevation-5' : 'elevation-2'">

                <v-overlay
                    :absolute="true"
                    :value="hideContents"
                    opacity="0.6"
                    class="h3"
                >
                    <slot name="overlay">
                    </slot>
                </v-overlay>

                <v-card-text :class="padding">
                    <slot></slot>
                </v-card-text>


            </v-card>
        </v-slide-y-transition>

        <help v-if="helpDialogModel"
              v-model="helpDialogModel"
              :identifier="help"
        ></help>

    </div>
</template>

<script>

import Help from '../../modules/Help/components/index';

export default {

    components: {
        Help
    },

    data() {
        return {
            isMouseOver: false,
            helpIconColor: 'grey lighten-1',
            helpDialogModel: false,
            timerRunning: false,
            timer: null,
        }
    },

    props: {
        title: {
            type: String,
            required: true,
            default: 'Title attribute not specified',
        },
        color: {
            type: String,
            required: false,
            default: '#484848'
        },
        sideIcon: {
            type: String | null,
            required: false,
            default: null
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'grey darken-2'
        },
        noPadding: {
            type: Boolean,
            required: false,
            default: false
        },
        noPaddingTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideContents: {
            type: Boolean,
            required: false,
            default: false,
        },
        help: {
            type: String,
            required: false,
            default: null
        },
        disableTitle: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    computed: {
        padding() {
            if (this.noPadding) return 'pa-0';
            if (this.noPaddingTop) return 'pl-5 pr-5 pb-5 pt-0'
            return 'pa-5'
        }
    },

    methods: {
        helpClicked() {
            this.helpDialogModel = true;
        },

        setMouseOver(bool) {

            // Use timers to fix flickering help icon
            if (bool === false) {

                if (!this.timerRunning) {
                    this.timer = setTimeout(() => {
                        this.isMouseOver = false;
                        this.timerRunning = false;
                    }, 100);
                }

                this.timerRunning = true;

            } else {

                if (this.timer) {
                    this.timerRunning = false;
                    clearTimeout(this.timer);
                }
                this.isMouseOver = true;
            }
        }
    }
}
</script>
